<template>
    <div>
        <b-modal
            v-model="mostrarModal"
            @show="abrirBoletoForm()"
        >
        <div slot="modal-title">
                Pagamento - Despesa
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label for="numeroNota">
                            Número da Nota/Fatura
                        </label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                placeholder="Digite o número da nota/fatura"
                                v-model="numeroNota"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="6">
                    <b-form-group>
                        <label 
                            for="dataVencimento"
                            v-bind:class="{
                                'required': boleto 
                            }"
                        >
                            Data de vencimento
                        </label>
                        <date-picker
                            ref="dp3"
                            id="dataVencimento"
                            v-model="dataVencimento"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            :disabled="movimentoCompra"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <label>
                    </label>
                    <b-checkbox
                        v-model="boleto"
                    >
                        Boleto
                    </b-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12"
                    v-if="dataVencimentoRequerJustificativa"
                >
                    <b-form-group>
                        <label class="required">Justificativa para Data de Vencimento</label>
                        <b-form-textarea
                            v-model="justificativaDataVencimento"
                            :rows="3"
                            @input="
                                $v.justificativaDataVencimento.$touch()
                            "
                            :state="
                                $v.justificativaDataVencimento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >É necessario justificar porque a data de vencimento tem um prazo menor que 15 dias
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharBoletoForm()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvarDespesa()"
                    class="ml-2"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        despesaId: {
            type: String
        },

        servicos: {
            type: Object
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            obterPagamentoAtualizado: false,
            numeroNota: null,
            boleto: null,
            dataVencimento: null,
            justificativaDataVencimento: null,
            movimentoCompra: false
        }
    },

    methods: {
        abrirBoletoForm() {
            this.obterPagamentoAtualizado = false
            this.obterDespesa()
        },

        preencherForm(despesa) {
            this.numeroNota = despesa.numeroNota
            this.boleto = despesa.boleto
            this.dataVencimento = despesa.dataVencimento != null ? this.$moment(despesa.dataVencimento).format('DD/MM/YYYY') : null
            this.justificativaDataVencimento = despesa.justificativaDataVencimento
            this.movimentoCompra = despesa.movimentoCompra
        },

        salvarDespesa() {
            this.mostrarModal = false
            this.$store.dispatch('addRequest')
            let despesaBoleto = {
                despesaId: this.despesaId,
                dataVencimento: this.dataVencimento != null ? this.$moment(this.dataVencimento, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                boleto: this.boleto,
                numeroNota: this.numeroNota,
                justificativaDataVencimento: this.dataVencimentoRequerJustificativa == true ? this.justificativaDataVencimento : null
            }
          
            this.servicos.ajustarBoleto(despesaBoleto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterPagamentoAtualizado = true
                        this.resetBoletoForm()
                        this.fecharBoletoForm()
                    } else {
                        this.erros = response.errors
                        this.mostrarModal = true
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDespesa() {
            this.$store.dispatch('addRequest')
            this.servicos.obterPorId(this.despesaId).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencherForm(response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter despesa!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        fecharBoletoForm() {
            this.mostrarModal = false
            if (this.obterPagamentoAtualizado) {
                this.$emit('obterPagamentoAtualizado')
            }
        },

        resetBoletoForm() {
            this.descritivo = ''
            this.tipoId = ''
            this.numero = null
            this.codigo = null
            this.dataEmissao = null
            this.pagamentoAnexoId = null
            this.arquivo = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
    },

    computed: {
        dataVencimentoRequerJustificativa() {
            if (this.dataVencimento == null
                || !this.boleto) {
                return false
            }

            let dtAtual = this.$moment(new Date())
            let dtVencimento = this.$moment(this.dataVencimento, 'DD/MM/YYYY')
            if (dtAtual > dtVencimento.subtract(15, 'days')) {
                return true
            }

            return false
        }
    },

    validations: {
        dataVencimento: {
            eBoleto() {
                if (this.boleto) {
                    return this.dataVencimento != null
                }
                return true
            }
        },

        justificativaDataVencimento: {
            eBoleto() {
                if (this.dataVencimentoRequerJustificativa) {
                    return this.justificativaDataVencimento != null
                        && this.justificativaDataVencimento != ''
                }
                return true
            }
        },
    }
}
</script>